<template>
  <div class="card-video">
    <div>
      <header class="card-video-header">
        <div>
          <h3>{{title}} </h3>
          <p>{{category}}</p>
        </div>
        <div>
          <p class="label" v-if="(today <= newReleaseEndDate)">{{ $t("tutoralsVideos.label") }}</p>
        </div>
      </header>
      <div class="video-playing">
        <iframe width="480" height="250" :src="link"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen></iframe>
        <footer class="card-video-footer"><p>{{description}}</p></footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardVideo',
  props: ['sectionId', 'category', 'link', 'description', 'title', 'newReleaseEndDate', 'counterVideos'],
  data () {
    return {
      today: {}
    }
  },
  beforeMount () {
    this.today = new Date().getTime()
  }
}
</script>

<style lang="scss" scoped>
.card-video{
  font-family: "Dosis", Helvetica, Arial, sans-serif;
  max-width: 480px;
  min-height: 430px;
  margin: 10px;
  background: white;
  &-header{
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    background-color: #FDEFDF;
    h3 {
      font-weight: bold;
      font-size: 1rem;
      text-transform: lowercase;
    }
    h3:first-letter {
      text-transform: uppercase;
    }
    .label{
      background-color: #50B2C0;
      color: white;
      padding: 2px 5px;
      border-radius: 15px;
    }
  }
  &-footer{
    background-color: #FDEFDF;
    min-height: 100px;
    padding: 10px 15px;
    p{
      color: black;
    }
  }
}
</style>
